import React from 'react'
import { cx, css } from '@emotion/css'
import Tooltip from '../../tooltip'

// 编辑器-工具栏-基础button组件
const BaseButton = function ({ tip, className, active, reversed, ...props }) {
  let color
  if (reversed) {
    color = active ? 'white' : '#aaa'
  } else color = active ? 'black' : '#ccc'
  return (
    <Tooltip
      className="bg-primary-50"
      trigger={
        <span
          {...props}
          className={cx(
            className,
            css`
              cursor: pointer;
              color: ${color};
            `
          )}
        />
      }
      position="bottom"
      on={['hover']}
    >
      <span>{tip}</span>
    </Tooltip>
  )
}

export default BaseButton
